<template>
  <div class="none" style="display: inline-flex">
    <div class="cursors" @click="handleOpen">
      <i class="el-icon-setting"></i>
    </div>
    <el-dialog
      :title="$t('common_words.crop_configuration')"
      :visible.sync="modals.read"
      :close-on-click-modal="false"
      width="20%"
    >
      <div class="row" style="margin: auto">
        <div class="col-12">
          <fg-input
            min="0"
            type="number"
            :label="`${$t('irrigation.wilting_lower_percentage')}: `"
            v-model="model.wilting"
            placeholder="15"
            name="irrigation.wilting"
            v-validate="modelValidations.wilting"
            :error="getError('irrigation.wilting', true)"
          />
        </div>
        <div class="col-12">
          <fg-input
            min="1"
            type="number"
            :label="`${$t('irrigation.saturation_higher_percentage')}: `"
            v-model="model.saturation"
            placeholder="25"
            name="irrigation.saturation"
            v-validate="modelValidations.saturation"
            :error="getError('irrigation.saturation', true)"
          />
        </div>
        <div class="text-center col-12 mb-3">
          <hr />
          <l-button wide type="info" class="btn-filter" @click="onSubmit">
            {{ $t('common_words.save') }}
          </l-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  name: 'point-and-saturation-form',
  data() {
    return {
      model: {
        wilting: this.wilting,
        saturation: this.saturation,
      },
      modals: {
        read: false,
      },
    };
  },
  computed: {
    modelValidations() {
      return {
        wilting: {
          required: true,
          min_value: 0,
          max_value:
            Number(this.model.saturation) - 1 < 0
              ? 0
              : Number(this.model.saturation) - 1,
        },
        saturation: {
          required: true,
          min_value: 1,
        },
      };
    },
  },
  props: {
    station: {
      type: Number,
    },
    wilting: {
      type: Number,
    },
    saturation: {
      type: Number,
    },
  },
  watch: {
    wilting(newValue) {
      this.model.wilting = newValue;
    },
    saturation(newValue) {
      this.model.saturation = newValue;
    },
  },
  mixins: [MixinForm, MixinMasters],
  methods: {
    handleOpen() {
      if (this.model.wilting === '' && this.model.saturation === '')
        this.$validator.errors.clear();
      this.modals.read = true;
    },

    onSubmit() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          this.closeModal('read');
          let data = {};
          data.route = 'devices/station/points';
          data.wilting_point = this.model.wilting;
          data.saturation_point = this.model.saturation;
          data.station = this.station;
          sessionStorage.setItem('changePoints', this.station);

          Axios.postMasters(data)
            .then(() => {
              this.$emit('getDataReport', 3);
              this.$emit(
                'updateBackground',
                Number(this.model.wilting) === 0 ||
                  Number(this.model.saturation) === 0
                  ? false
                  : true
              );

              this.$emit('handleChangeSwitch');
            })
            .catch((error) => {
              console.log(error);
              this.showMessageErrors(error);
            });
        }
      });
    },
  },
};
</script>
